
import { ButtonFieldConfig, DynamicFormArray, FormFieldConfig, SECTION_TYPE, TabConfig } from './form.model';
import { defaultSearchContainerButtons, CertifiableRolesDropdown, DealerDropdown, NonCertifiableRolesDropdown, FieldNames, DropdownOptions, DefaultDropdown } from './form-fields.model';
import { DataTableSchema, DefaultTableSchema } from './dynamic-data-table.model';
import { FETCH_METHODS, SearchConfig } from './api.model';
import { OptionsFetchConfig } from './common.model';
import { FilterListContainerComponent } from '../layout/filter-list-container/filter-list-container.component';

export const RegionName= 'Region Name';
export const certLevel= 'Cert Level';
export const aseBlockCredit ="ASE Block Credit";
export const viewSharePointLink = 'View Share Point Link';
export const BrandSelectionFieldName = 'brandSelection';
export const jobDescription = 'Job Description';
const FormButtonArray: ButtonFieldConfig[] = structuredClone(defaultSearchContainerButtons);
export const InformationTitle = "Information";

export const LexusAreasTableData = DropdownOptions[FieldNames.Area].map((option, index) => ({
    sno: index + 1,
    areaCode: option.fieldValue,
    areaName: option.fieldLabel
}));

export const ToyotaCertificationsTableData = DropdownOptions[FieldNames.ToyotaCertification].map((option, index) => ({
    sno: index + 1,
    certificationName: option.fieldLabel,
    certLevel: option.fieldValue,
}));

export const LexusCertificationsTableData = DropdownOptions[FieldNames.Certification].map((option, index) => ({
    sno: index + 1,
    certificationName: option.fieldLabel,
    certLevel: option.fieldValue,

}));

export const transformToyotaRegionData = (apiResponse: any): any[] => {
    const regions = apiResponse?.result?.[0]?.toyotaregions || [];
    return regions.map((region: { regionCode: string; regionName: string }, index: number) => ({
        sno: index + 1,
        regionCode: region.regionCode,
        regionName: region.regionName
    }));
};


export const transformToyotaJobsData = (apiResponse: any): any[] => {
    const toyotaJobs = apiResponse?.result?.[0]?.result_json?.jobs?.toyotaJobs || [];
    return toyotaJobs.map((job: any, index: number) => ({
        sno: index + 1,
        jobDescription: job.jobDescription,
        jobCode: job.jobCode
    }));
};

export const transformLexusJobsData = (apiResponse: any): any[] => {
    const lexusJobs = apiResponse?.result?.[0]?.result_json?.jobs?.lexusJobs || [];
    return lexusJobs.map((job: any, index: number) => ({
        sno: index + 1,
        jobDescription: job.jobDescription,
        jobCode: job.jobCode
    }));
};

export const transformToyotaDealersData = (apiResponse: any): any[] => {
    const toyotaDealers = apiResponse?.result?.[0]?.result_json?.dealer?.toyotaDealer || [];
    return toyotaDealers.map((dlr: any, index: number) => ({
        sno: index + 1,
        dealerCode: dlr.dealer_num,
        dealerName: dlr.acct_name,
        regionName:dlr.area
    }));
};

export const transformLexusDealersData = (apiResponse: any): any[] => {
    const lexusDealers = apiResponse?.result?.[0]?.result_json?.dealer?.lexusDealer || [];
    return lexusDealers.map((dlr: any, index: number) => {
        return {
            sno: index + 1,
            dealerCode: dlr.dealer_num,
            dealerName: dlr.acct_name,
            areaName:dlr.area
        };
    });
};

export const transformCertifiableRolesData = (apiResponse: any): any[] => {
    const roles = apiResponse?.result?.[0]?.certifiableRoles || [];
    return roles.map((role: string, index: number) => ({
        sno: index + 1,
        jobRoleName: role
    }));
};

export const transformNonCertifiableRolesData = (apiResponse: any): any[] => {
    const roles = apiResponse?.result?.[0]?.nonCertifiableRoles || [];
    return roles.map((role: string, index: number) => ({
        sno: index + 1,
        jobRoleName: role
    }));
};

export const transformDealerBillingCoursesData = (apiResponse: any): any[] => {
    const courses = apiResponse?.result || [];
    return courses.map((course: any, index: number) => ({
        sno: index + 1,
        courseName: course.title
    }));
};

export const BrandSelectionOptions = (DropdownOptions[FieldNames.Brand] || []).map((option) => ({
    fieldLabel: option.fieldLabel,
    fieldValue: String(option.fieldValue).toLowerCase()
}));

const BrandSelectionFilter: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: BrandSelectionFieldName,
    displayName: 'Brand',
    options: BrandSelectionOptions,
    defaultValue: 'lexus',
    selectedValue: 'lexus',
    required: true,
    showSelect:false,
    disabled: false
};

const FormFieldArray: FormFieldConfig[] = structuredClone([
    { ...structuredClone(CertifiableRolesDropdown), isLoading: true },
    { ...structuredClone(NonCertifiableRolesDropdown), isLoading: true },
    { ...structuredClone(DealerDropdown), isLoading: true }
]);

export const InformationDynamicOptionFields: OptionsFetchConfig = {
    fields: [
        { name: FieldNames['CertifiableRoles'], keyValuePair: { fieldLabel: '', fieldValue: '' } },
        { name: FieldNames['NonCertifiableRoles'], keyValuePair: { fieldLabel: '', fieldValue: '' } },
        { name: FieldNames['DealerNumber'], keyValuePair: { fieldLabel: '', fieldValue: '' } }],
    searchConfig: {
        path: 'jobSummaryDropdown',
        method: FETCH_METHODS['Get'],
        body: {}
    }
}

export const searchGetConfig: SearchConfig = {
    method: FETCH_METHODS['Post'],
    path: 'jobEnrollmentSummary',
    body: {
        "area": "",
        "certifiableRoles": "",
        "nonCertifiableRoles": "",
        "dealerNumber": "",
        "certification": ""
    }
}


export const InformationFormArray: DynamicFormArray = {
    FieldsArray: FormFieldArray,
    ButtonsArray: FormButtonArray,
    searchConfig: searchGetConfig,
}

export const InformationTabIds = {
    totalLexusJobRoles: 'Job Roles',
    certifiableJobRoles: 'Certifiable Job Roles',
    nonCertifiableJobRoles: 'Lexus Non Certifiable Job Roles',
    lexusAreas: 'Area/Region',
    lexusDealers: 'Dealers',
    toyotaRegion: 'Toyota Region',
    lexusCertification: 'Certification',
    buySellDealers: 'Buy/Sell Dealers',
    dealerBillingCourses: 'Dealer Billing Course',
    aseStatus: 'ASE Status',
    aseTechRejectionJobRoles: 'ASE Tech Rejection Job Roles',
    aseCollisionRejectionJobRoles: 'ASE Collision Rejection Job Roles'
}

export const AseStatusTableData = [
  {sno: 1, status: 'N', statusValue: 'NO MATCH', statusDescription: 'ASE ID# and SPIN does not match and/or no ASE credit to send'},
  {sno: 2, status: 'NR', statusValue: 'NO RELEASE', statusDescription: 'This box can only be unchecked by the Tech'},
  {sno: 3, status: 'SX', statusValue: aseBlockCredit, statusDescription: 'Incomplete experience information'},
  {sno: 4, status: 'EX', statusValue: aseBlockCredit, statusDescription: 'Certification Expired'},
  {sno: 5, status: 'BL', statusValue: aseBlockCredit, statusDescription: 'Tech needs to call; i.e ASE payment due'}
];

export const rejectionLexusJobs = [
    { sno: 1, jobCode: '012', jobDescription: 'SERVICE TECHNICIAN' },
    { sno: 2, jobCode: '013', jobDescription: 'TECHNICIAN APPRENTICE' },
    { sno: 3, jobCode: '015', jobDescription: 'DIAGNOSTIC SPECIALIST' },
    { sno: 4, jobCode: '016', jobDescription: 'TEAM LEADER' },
    { sno: 5, jobCode: '074', jobDescription: 'SERV TRAINING SPECIALIST' },
    { sno: 6, jobCode: '020', jobDescription: 'SERVICE CONSULTANT' },
    { sno: 7, jobCode: '073', jobDescription: 'FIELD TECH SPECIALIST' },
    { sno: 8, jobCode: '075', jobDescription: 'DIST SERV MANAGER' },
    { sno: 9, jobCode: '014', jobDescription: 'SHOP FOREMAN' },
    { sno: 10, jobCode: '079', jobDescription: 'FIELD PRODUCT ENGINEER' }
];

export const rejectionToyotaJobs = [
    { sno: 1, jobCode: '012', jobDescription: 'LINE TECHNICIAN' },
    { sno: 2, jobCode: '013', jobDescription: 'TECHNICIAN APPRENTICE' },
    { sno: 3, jobCode: '014', jobDescription: 'SHOP FOREMAN' },
    { sno: 4, jobCode: '015', jobDescription: 'DIAGNOSTIC SPECIALIST' },
    { sno: 5, jobCode: '016', jobDescription: 'TEAM LEADER' },
    { sno: 6, jobCode: '073', jobDescription: 'FIELD TECH SPECIALIST' },
    { sno: 7, jobCode: '074', jobDescription: 'SERV TRAINING SPECIALIST' },
    { sno: 8, jobCode: '075', jobDescription: 'DIST SERV MANAGER' },
    { sno: 9, jobCode: '079', jobDescription: 'FIELD PRODUCT ENGINEER' }
];

export const collisionLexusJobs = [
    { sno: 1, jobCode: '032', jobDescription: 'COLLISION CENTER MANAGER' },
    { sno: 2, jobCode: '053', jobDescription: 'COLLISION REPAIR SPECIALIST' },
    { sno: 3, jobCode: '054', jobDescription: 'REFINISH SPECIALIST' },
    { sno: 4, jobCode: '065', jobDescription: 'DEALER BODY SHOP ESTIMATOR' }
];

export const collisionToyotaJobs = [
    { sno: 1, jobCode: '032', jobDescription: 'DEALER BODY SHOP MANAGER' },
    { sno: 2, jobCode: '053', jobDescription: 'DEALER BODY SHOP METAL WORKER' },
    { sno: 3, jobCode: '054', jobDescription: 'DEALER BODY SHOP PAINTER' },
    { sno: 4, jobCode: '053', jobDescription: 'DEALER BODY SHOP PAINTER' },
    { sno: 5, jobCode: '065', jobDescription: 'DEALER BODY SHOP ESTIMATOR' }
];

//Table Schema
export const LexusTableSchema: DataTableSchema = {
    ...structuredClone(DefaultTableSchema),
    columnSchema: [
        { label: "S.No", fieldKey: "sno" },
        { label: "Area Code", fieldKey: "areaCode" },
        { label: "Area Name", fieldKey: "areaName" }
    ],
    isSearchRequired: true,
    searchInfo: {
        placeholder: 'Filter',
        filtarableSpecificFields: []
    },
    exportConfig: {
        fileName: 'Lexus_Area_Summary',
        exportMessage: "Lexus Area Summary",
        exportCritiria: true,
        isCamelCase: ['areaName'],
        schema: {
            sno: "S.NO",
            areaCode: "AREA CODE",
            areaName: "AREA NAME"
        },
    },
    breadcrums: [{ level: 1, name: InformationTitle }]
}

export const ToyotaTableSchema: DataTableSchema = {
    ...structuredClone(DefaultTableSchema),
    columnSchema: [
        { label: "S.No", fieldKey: "sno" },
        { label: "Region Code", fieldKey: "regionCode" },
        { label: RegionName, fieldKey: "regionName" }
    ],
    isSearchRequired: true,
    searchInfo: {
        placeholder: 'Filter',
        filtarableSpecificFields: []
    },
    exportConfig: {
        fileName: 'Toyota_Region_Summary',
        exportMessage: "Toyota Region Summary",
        exportCritiria: true,
        isCamelCase: ['regionName'],
        schema: {
            sno: "S.NO",
            regionCode: "REGION CODE",
            regionName: "REGION NAME"
        },
    },
    breadcrums: [{ level: 1, name: InformationTitle }]
}

export const CertifiableJobRolesTableSchema: DataTableSchema = {
    ...structuredClone(DefaultTableSchema),
    columnSchema: [
        { label: "S.No", fieldKey: "sno" },
        { label: "Job Name", fieldKey: "jobRoleName" }
    ],
    isSearchRequired: true,
    searchInfo: {
        placeholder: 'Filter',
        filtarableSpecificFields: []
    },
    exportConfig: {
        fileName: 'Certifiable_Job_Roles',
        exportMessage: "Certifiable Job Roles",
        exportCritiria: true,
        isCamelCase: ['jobRoleName'],
        schema: {
            sno: "S.NO",
            jobRoleName: "JOB NAME"
        },
    },
    breadcrums: [{ level: 1, name: InformationTitle }]
}

export const LexusDealersTableSchema: DataTableSchema = {
    ...structuredClone(DefaultTableSchema),
    columnSchema: [
        { label: "S.No", fieldKey: "sno" },
        { label: "Dealer Code", fieldKey: "dealerCode" },
        { label: "Dealer Name", fieldKey: "dealerName" },
        { label: "Area", fieldKey: "areaName" }
    ],
    isSearchRequired: true,
    searchInfo: {
        placeholder: 'Filter',
        filtarableSpecificFields: []
    },
    headerActions: [
        {
            fieldKey: 'ExportDealersLink',
            actionLabel: viewSharePointLink,
            iconClass: '',
            toolTip: viewSharePointLink,
            actionName: 'Share Point Link',
            isLink: true,
            link: 'https://myteams.toyota.com/:x:/r/sites/NA-005/Shared%20Documents/Lexus_Activeonly.xlsx?web=1&csf=1&web=1&e=0s07Bc'
        }
    ],
    exportConfig: {
        fileName: 'Lexus_Dealers_Summary',
        exportMessage: "Lexus Dealers Summary",
        exportCritiria: true,
        isCamelCase: ['dealerName','areaName'],
        schema: {
            sno: "S.NO",
            dealerCode: "DEALER CODE",
            dealerName: "DEALER NAME",
            areaName:"Area"
        },
    },
    breadcrums: [{ level: 1, name: InformationTitle }]
}

export const ToyotaDealersTableSchema: DataTableSchema = {
    ...structuredClone(DefaultTableSchema),
    columnSchema: [
        { label: "S.No", fieldKey: "sno" },
        { label: "Dealer Code", fieldKey: "dealerCode" },
        { label: "Dealer Name", fieldKey: "dealerName" },
        { label: RegionName, fieldKey: "regionName" }
    ],
    isSearchRequired: true,
    searchInfo: {
        placeholder: 'Filter',
        filtarableSpecificFields: []
    },
    headerActions: [
        {
            fieldKey: 'ExportDealersLink',
            actionLabel: viewSharePointLink,
            iconClass: '',
            toolTip: viewSharePointLink,
            actionName: 'Share Point Link',
            isLink: true,
            link: 'https://myteams.toyota.com/:x:/r/sites/NA-005/Shared%20Documents/Toyota_Activeonly.xlsx?web=1&csf=1&web=1&e=2jtrEZ'
        }
    ],
    exportConfig: {
        fileName: 'Toyota_Dealers_Summary',
        exportMessage: "Toyota Dealers Summary",
        exportCritiria: true,
        isCamelCase: ['dealerName', 'regionName'],
        schema: {
            sno: "S.NO",
            dealerCode: "DEALER CODE",
            dealerName: "DEALER NAME",
            regionName:RegionName
        },
    },
    breadcrums: [{ level: 1, name: InformationTitle }]
}

export const ToyotaCertificationTableSchema: DataTableSchema = {
    ...structuredClone(DefaultTableSchema),
    columnSchema: [
        { label: "S.No", fieldKey: "sno" },
        { label: "Certification Name", fieldKey: "certificationName" },
        { label: certLevel, fieldKey: "certLevel" },
    ],
    isSearchRequired: true,
    searchInfo: {
        placeholder: 'Filter',
        filtarableSpecificFields: []
    },
    exportConfig: {
        fileName: 'Toyota_Certification_Summary',
        exportMessage: "Toyota Certification Summary",
        exportCritiria: true,
        isCamelCase: ['certificationName'],
        schema: {
            sno: "S.NO",
            certificationName: "CERTIFICATION NAME",
            certLevel:certLevel
        },
    },
    
    breadcrums: [{ level: 1, name: InformationTitle }]
}

export const LexusCertificationTableSchema: DataTableSchema = {
    ...structuredClone(DefaultTableSchema),
    columnSchema: [
        { label: "S.No", fieldKey: "sno" },
        { label: "Certification Name", fieldKey: "certificationName" },
        { label: certLevel, fieldKey: "certLevel" }
    ],
    isSearchRequired: true,
    searchInfo: {
        placeholder: 'Filter',
        filtarableSpecificFields: []
    },
    exportConfig: {
        fileName: 'Lexus_Certification_Summary',
        exportMessage: "Lexus Certification Summary",
        exportCritiria: true,
        isCamelCase: ['certificationName'],
        schema: {
            sno: "S.NO",
            certificationName: "CERTIFICATION NAME",
            certLevel:certLevel
        },
    },
    pageSizeOptions: {
        pageSize: [10, 25, 50, 100]
    },
    breadcrums: [{ level: 1, name: InformationTitle }]
}

export const BuySellDealersTableSchema: DataTableSchema = {
    ...structuredClone(DefaultTableSchema),
    columnSchema: [
        { label: "S.No", fieldKey: "sno" },
        { label: "Old Dealer Code", fieldKey: "oldDealerCode" },
        { label: "Old Dealer Name", fieldKey: "oldDealerName" },
        { label: "New Dealer Code", fieldKey: "dealerCode" },
        { label: "New Dealer Name", fieldKey: "dealerName" },
        { label: "Buy/Sell Date", fieldKey: "termDate" }
    ],
    isSearchRequired: true,
    searchInfo: {
        placeholder: 'Filter',
        filtarableSpecificFields: []
    },
    exportConfig: {
        fileName: 'Buy_Sell_Dealers_Summary',
        exportMessage: "Buy Sell Dealers Summary",
        exportCritiria: true,
        isCamelCase: ['oldDealerName','dealerName'],
        schema: {
            sno: "S.NO",
            oldDealerCode: "OLD DEALER CODE",
            oldDealerName: "OLD DEALER NAME",
            dealerCode: "NEW DEALER CODE",
            dealerName: "NEW DEALER NAME",
            termDate: "Buy/Sell Date"
        },
    },
    pageSizeOptions: {
        pageSize: [10, 25, 50, 100]
    },
    breadcrums: [{ level: 1, name: InformationTitle }]
}

export const TotalLexusJobRolesTableSchema: DataTableSchema = {
    ...structuredClone(DefaultTableSchema),
    columnSchema: [
        { label: "S.No", fieldKey: "sno" },
        { label: "Job Code", fieldKey: "jobCode" },
        { label: "Job Name", fieldKey: "jobDescription" }
    ],
    isSearchRequired: true,
    searchInfo: {
        placeholder: 'Filter',
        filtarableSpecificFields: []
    },
    exportConfig: {
        fileName: 'Lexus_Job_Roles',
        exportMessage: "Lexus Job Roles",
        exportCritiria: true,
        isCamelCase: ['jobDescription'],
        schema: {
            sno: "S.NO",
            jobCode: "Job Code",
            jobDescription:"Job Name",
        },
    },
    pageSizeOptions: {
        pageSize: [10, 25, 50, 100]
    },
    breadcrums: [{ level: 1, name: InformationTitle }]
}

export const TotalToyotaJobRolesTableSchema: DataTableSchema = {
    ...structuredClone(DefaultTableSchema),
    columnSchema: [
        { label: "S.No", fieldKey: "sno" },
        { label: "Job Code", fieldKey: "jobCode" },
        { label: "Job Name", fieldKey: "jobDescription" },
    ],
    isSearchRequired: true,
    searchInfo: {
        placeholder: 'Filter',
        filtarableSpecificFields: []
    },
    exportConfig: {
        fileName: 'Toyota_Job_Roles',
        exportMessage: "Toyota Job Roles",
        exportCritiria: true,
        isCamelCase: ['jobDescription'],
        schema: {
            sno: "S.NO",
            jobCode: "Job Code",
            jobDescription:"Job Name",
        },
    },
    pageSizeOptions: {
        pageSize: [10, 25, 50, 100]
    },
    breadcrums: [{ level: 1, name: InformationTitle }]
}

export const DealerBillingCoursesTableSchema: DataTableSchema = {
    ...structuredClone(DefaultTableSchema),
    columnSchema: [
        { label: "S.No", fieldKey: "sno" },
        { label: "Course Name", fieldKey: "courseName",isNotCamelCase: true  }
    ],
    isSearchRequired: true,
    searchInfo: {
        placeholder: 'Filter',
        filtarableSpecificFields: []
    },
    exportConfig: {
        fileName: 'Dealer_Billing_Courses',
        exportMessage: "Dealer Billing Courses",
        exportCritiria: true,
        schema: {
            sno: "S.NO",
            courseName: "COURSE NAME"
        },
    },
    pageSizeOptions: {
        pageSize: [10, 25, 50, 100]
    },
    breadcrums: [{ level: 1, name: InformationTitle }]
}

export const AseStatusTableSchema: DataTableSchema = {
    ...structuredClone(DefaultTableSchema),
    columnSchema: [
        { label: "S.No", fieldKey: "sno" },
        { label: "Status", fieldKey: "status",isUpperCase:true },
        { label: "Status Value", fieldKey: "statusValue" },
        { label: "Status Description", fieldKey: "statusDescription",isNotCamelCase:true}
    ],
    isSearchRequired: true,
    searchInfo: {
        placeholder: 'Filter',
        filtarableSpecificFields: []
    },
    exportConfig: {
        fileName: 'ASE_Status_Summary',
        exportMessage: "ASE Status Summary",
        exportCritiria: true,
        schema: {
            sno: "S.NO",
            status: "STATUS",
            statusValue: "STATUS VALUE",
            statusDescription: "STATUS DESCRIPTION"
        },
    },
    breadcrums: [{ level: 1, name: InformationTitle }]
};

const AseJobRolesColumnSchema = [
    { label: 'S.NO', fieldKey: 'sno' },
    { label: 'Job Code', fieldKey: 'jobCode' },
    { label: jobDescription, fieldKey: 'jobDescription' }
];

export const AseTechRejectionJobRolesTableSchema: DataTableSchema = {
    ...structuredClone(DefaultTableSchema),
    columnSchema: AseJobRolesColumnSchema,
    searchInfo: {
        placeholder: 'Filter',
        filtarableSpecificFields: []
    },
    isSearchRequired: true,
    isExportRequired: true,
    displayedColumns: ['sno', 'jobCode', 'jobDescription'],
    exportConfig: {
    fileName: 'ASE_Tech_Rejection_Job_Roles',
    exportMessage: "ASE Tech Rejection Job Roles",
    exportCritiria: true,
    isCamelCase: ['jobDescription'],
    schema: {
        sno: "S.NO",
        jobCode: "Job Code",
        jobDescription: jobDescription
    },
    },
    pageSizeOptions: {
      pageSize: [10, 25, 50, 100]
    },
        dataSource: structuredClone(rejectionLexusJobs),
    breadcrums: [{ level: 1, name: InformationTitle }]
};

export const AseCollisionRejectionJobRolesTableSchema: DataTableSchema = {
    ...structuredClone(DefaultTableSchema),
    columnSchema: AseJobRolesColumnSchema,
    searchInfo: {
        placeholder: 'Filter',
        filtarableSpecificFields: []
    },
    isSearchRequired: true,
    isExportRequired: true,
    displayedColumns: ['sno', 'jobCode', 'jobDescription'],
    exportConfig: {
    fileName: 'ASE_Collision_Rejection_Job_Roles',
    exportMessage: "ASE Collision Rejection Job Roles",
    exportCritiria: true,
    isCamelCase: ['jobDescription'],
    schema: {
        sno: "S.NO",
        jobCode: "Job Code",
        jobDescription: jobDescription
    },
    },
    pageSizeOptions: {
      pageSize: [10, 25, 50, 100]
    },
        dataSource: structuredClone(collisionLexusJobs),
    breadcrums: [{ level: 1, name: InformationTitle }]
};

//Tab Information
export const InformationTableSchema: DataTableSchema = LexusTableSchema;

export const InformationTabConfig: Array<TabConfig> = [
    {
        label: InformationTabIds.lexusAreas,
        tabId: InformationTabIds.lexusAreas,
        type: SECTION_TYPE.List,
        component: FilterListContainerComponent,
        searchKey: 'areaRegion',
        inputs: {
            DataTableSchema: structuredClone(LexusTableSchema),
            props: { isSearchVisible: true },
            forSection: true,
            filterSchema: {
                FieldsArray: structuredClone([BrandSelectionFilter]),
            },
            dataInput: LexusAreasTableData
        }
    },
    {
        label: InformationTabIds.certifiableJobRoles,
        tabId: InformationTabIds.certifiableJobRoles,
        type: SECTION_TYPE.List,
        component: FilterListContainerComponent,
        searchKey: 'certifiableJobRoles',
        inputs: {
            DataTableSchema: structuredClone(CertifiableJobRolesTableSchema),
            props: { isSearchVisible: true },
            dataInput: [],
            forSection:true,
            filterSchema: {
                FieldsArray: structuredClone([BrandSelectionFilter]),
            },
            apiConfig: {
                method: FETCH_METHODS['Get'],
                path: 'jobSummaryDropdown',
                body: {}
            },
            dataTransform: transformCertifiableRolesData
        }
    },
    {
        label: InformationTabIds.totalLexusJobRoles,
        tabId: InformationTabIds.totalLexusJobRoles,
        type: SECTION_TYPE.List,    
        component: FilterListContainerComponent,
        searchKey: 'jobRoles',
        inputs: {
            DataTableSchema: structuredClone(TotalLexusJobRolesTableSchema),
            props: { isSearchVisible: true },
            dataInput: [],
            forSection:true,
            filterSchema: {
                FieldsArray: structuredClone([BrandSelectionFilter]),
            },
            apiConfig: {
                method: FETCH_METHODS['Post'],
                path: 'getDropdownsForTenure',
                body: {}
            }
        }
    },
    {
        label: InformationTabIds.lexusDealers,
        tabId: InformationTabIds.lexusDealers,
        type: SECTION_TYPE.List,
        component: FilterListContainerComponent,
        searchKey: 'dealers',
        inputs: {
            forSection:true,
            DataTableSchema: structuredClone(LexusDealersTableSchema),
            props: { isSearchVisible: true },
            filterSchema: {
                FieldsArray: structuredClone([BrandSelectionFilter]),
            },
            dataInput: []
        }
    },
    {
        label: InformationTabIds.lexusCertification,
        tabId: InformationTabIds.lexusCertification,
        type: SECTION_TYPE.List,
        component: FilterListContainerComponent,
        searchKey: 'certification',
        inputs: {
            DataTableSchema: structuredClone(LexusCertificationTableSchema),
           props: { isSearchVisible: true },
           forSection:true,
           filterSchema: {
                FieldsArray: structuredClone([BrandSelectionFilter]),
            },
        }
    },
    {
        label: InformationTabIds.buySellDealers,
        tabId: InformationTabIds.buySellDealers,
        type: SECTION_TYPE.List,
        component: FilterListContainerComponent,
        searchKey: 'buySellDealers',
        inputs: {
            DataTableSchema: structuredClone(BuySellDealersTableSchema),
            props: { isSearchVisible: true },
            forSection:true,
            filterSchema: {
                FieldsArray: []
            },
            dataInput: [],
        }
    },
    {
        label: InformationTabIds.dealerBillingCourses,
        tabId: InformationTabIds.dealerBillingCourses,
        type: SECTION_TYPE.List,
        component: FilterListContainerComponent,
        searchKey: 'dealerBillingCourses',
        inputs: {
            DataTableSchema: structuredClone(DealerBillingCoursesTableSchema),
            props: { isSearchVisible: true },
           forSection:true,
            filterSchema: {
                FieldsArray: []
            },
            dataInput: []
        }
    },
    {
        label: InformationTabIds.aseStatus,
        tabId: InformationTabIds.aseStatus,
        type: SECTION_TYPE.List,
        component: FilterListContainerComponent,
        searchKey: 'aseStatus',
        inputs: {
            DataTableSchema: structuredClone(AseStatusTableSchema),
            props: { isSearchVisible: true },
            dataInput: AseStatusTableData,
            filterSchema: {
                FieldsArray: []
            },
            forSection:true
        }
    },
    {
        label: InformationTabIds.aseTechRejectionJobRoles,
        tabId: InformationTabIds.aseTechRejectionJobRoles,
        type: SECTION_TYPE.List,
        component: FilterListContainerComponent,
        searchKey: 'aseTechRejectionJobRoles',
        inputs: {
            DataTableSchema: AseTechRejectionJobRolesTableSchema,
            props: { isSearchVisible: true },
            forSection:true,
            filterSchema: {
                FieldsArray: structuredClone([BrandSelectionFilter]),
            },
            dataInput: structuredClone(rejectionLexusJobs)
        }
    },
    {
        label: InformationTabIds.aseCollisionRejectionJobRoles,
        tabId: InformationTabIds.aseCollisionRejectionJobRoles,
        type: SECTION_TYPE.List,
        component: FilterListContainerComponent,
        searchKey: 'aseCollisionRejectionJobRoles',
        inputs: {
            DataTableSchema: AseCollisionRejectionJobRolesTableSchema,            
            props: { isSearchVisible: true },
            forSection:true,
            filterSchema: {
                FieldsArray: structuredClone([BrandSelectionFilter]),
            },
            dataInput: structuredClone(collisionLexusJobs)
        }
    }
];

